<template>
  <div class="miscellaneous">
    <div
      class="vx-row details"
      v-for="(miscellaneous_doc,index) in data.miscellaneous_document"
      :key="index"
    >
      <div class="vx-col flex w-full mb-6">
        <label class="font-bold pr-4">Description:</label>
        <p>{{miscellaneous_doc.description}}</p>
      </div>
      <div class="vx-col w-full flex">
        <label class="font-bold pr-4">Document:</label>
        <div class="flex overflow-x-auto">
          <span
            v-for="(doc,dindex) in miscellaneous_doc.docType"
            :key="dindex"
            class="pr-0 image-size"
          >
            <div class="mr-2 mb-4">
              <a :href="doc.url" target="_blank" v-if="doc.doc_type === 'image'">
                <img :src="doc.url" width="100" alt="Image" />
              </a>
              <a :href="doc.url" target="_blank" class="file" v-if="doc.doc_type === 'word'">
                <img width="100" src="@/assets/images/pages/doc.svg" alt="Document" />
              </a>
              <a :href="doc.url" target="_blank" class="file" v-if="doc.doc_type === 'pdf'">
                <img width="100" src="@/assets/images/pages/pdf.svg" alt="PDFd" />
              </a>
            </div>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      data: "",
      document_url: [],
      fileType: "",
      doc_type: ""
    };
  },
  props: ["consultantId", "serviceId"],
  computed: {},
  mounted() {
    this.getMiscellaneousData();
  },
  methods: {
    async getMiscellaneousData() {
      let input = {
        project_id: this.$route.params.id,
        consultant_id: this.consultantId,
        service_id: this.serviceId
      };
      let response = await this.getHTTPPostResponse(
        "miscellaneous-documents/list",
        input
      );
      if (response) {
        var data = response.data;
        this.data = response.data;
        data.miscellaneous_document.forEach(element => {
          var doc_type_arr = [];
          element.document.forEach(el => {
            var doc_url = {
              url: "",
              doc_type: ""
            };
            var file_list = el;
            var extension = file_list.split(".").pop();

            if (["png", "jpeg", "jpg", "gif"].includes(extension)) {
              doc_url.url = el;
              doc_url.doc_type = "image";
            }
            if (["doc", "docx"].includes(extension)) {
              doc_url.url = el;
              doc_url.doc_type = "word";
            }
            if (["pdf"].includes(extension)) {
              doc_url.url = el;
              doc_url.doc_type = "pdf";
            }
            doc_type_arr.push(doc_url);
          });
          element.docType = doc_type_arr;
        });
      }
    }
  }
};
</script>
<style scoped>
.add-doc {
  float: right;
  top: -71px;
  top: -50px;
  right: 20px;
  position: absolute;
}
.details {
  border: 1px solid #e6e6e6;
  border-radius: 3px;
  margin-bottom: 10px;
  padding: 10px 0px;
}
</style>
